import { Outlet, useNavigate } from 'react-router';

import { ROTA_SENHA } from '@/features/auth/requer-sessao';
import { useResumoPendencias } from '@/features/pendencias/api';
import { useAuth, useUsuario } from '@/lib/auth/contexto';
import { podeEmAlguma } from '@/lib/auth/permissoes';
import { definirEscopo, useEscopoEmpresas } from '@/lib/escopo';
import { CascaApp } from '@/ui/shell/casca-app';
import { MenuUsuario } from '@/ui/shell/menu-usuario';
import { SeletorEmpresas } from '@/ui/shell/seletor-empresas';

import { navegacaoPara } from './navegacao';
import { NOME_PRODUTO } from './produto';

export function LayoutAutenticado() {
  const usuario = useUsuario();
  const { sair } = useAuth();
  const navegar = useNavigate();
  const escopo = useEscopoEmpresas();
  const empresas = usuario.vinculos.map((v) => ({
    id: v.empresa.id,
    nome: v.empresa.nomeFantasia ?? v.empresa.razaoSocial,
    documento: v.empresa.cnpj,
  }));
  // Escopo guardado de outra sessão pode citar empresa que a pessoa não acessa mais.
  const valido = escopo.filter((id) => empresas.some((e) => e.id === id));
  // Contador do menu: pendências de prioridade alta no escopo (só para quem lê documentos).
  const resumo = useResumoPendencias(valido, {}, podeEmAlguma(usuario, 'documentos.ler'));
  const pendenciasAltas = resumo.data?.porPrioridade.ALTA;

  return (
    <CascaApp
      nomeProduto={NOME_PRODUTO}
      navegacao={navegacaoPara(usuario, pendenciasAltas ? { pendenciasAltas } : {})}
      escopo={<SeletorEmpresas empresas={empresas} selecionadas={valido} aoMudar={definirEscopo} />}
      usuario={
        <MenuUsuario
          nome={usuario.nome}
          email={usuario.email}
          papel={usuario.perfilPlataforma?.nome}
          aoTrocarSenha={() => void navegar(ROTA_SENHA)}
          aoSair={() => void sair()}
        />
      }
    >
      <Outlet />
    </CascaApp>
  );
}
